import { configureStore } from '@reduxjs/toolkit'
import widgetExecutionsSlice from '../components/widgetExecutions/widgetExecutionsSlice'

export const store = configureStore({
  reducer: {
    widgetExecutions: widgetExecutionsSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch